import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AerovalesService } from '@despacho/aerovales.service';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { FacturacionService } from '@facturacion/facturacion.service';
import { NgbCalendar, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EstadoFactura } from '@shared/enums/EstadoFactura';
import { LegajosBusqueda } from '@shared/enums/LegajosBusqueda';
import { Motivo } from '@shared/enums/Motivo';
import { EstadoAerovale } from '@shared/enums/estadoAerovale';
import { TipoSolicitudRefacturacion } from '@shared/enums/facturacion/TipoSolicitudRefacturacion';
import { ExportExcelServiceService } from '@shared/exportar-excel/export-excel-service.service';
import { ErrorModel } from '@shared/models/ErrorModel';
import { AerovaleDetalle } from '@shared/models/despacho/AerovaleDetalle';
import { Comprobante } from '@shared/models/facturacion';
import { Factura } from '@shared/models/facturacion/Factura';
import { TipoMovimiento } from '@shared/models/facturacion/TipoMovimiento';
import { LegajoAerovalesYFacturas } from '@shared/models/reportes/legajos/LegajoAerovalesYFacturas';
import { ItemMultiFiltro } from '@shared/multifiltro/ItemMultifiltro';
import { ItemMultifiltroComponent } from '@shared/multifiltro/item-multifiltro/item-multifiltro.component';
import { SharedService } from '@shared/shared.service';
import { MessageService } from '@shell/message.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-legajos-aerovales-facturas',
  templateUrl: './legajos-aerovales-facturas.component.html',
  styleUrl: './legajos-aerovales-facturas.component.scss'
})

export class LegajosAerovalesFacturasComponent implements OnInit {
  busquedaFormControl = new FormControl();

  modelDesde: NgbDateStruct;
  modelHasta: NgbDateStruct;

  minFechaHasta: NgbDateStruct;
  maxFechaHasta: NgbDateStruct;
  cargandoLista: boolean;
  primerLlamado: boolean = false;

  startDate: Date;
  endDate: Date;

  previsualizando: boolean;
  previsualizandoAerovale: boolean;
  itemSeleccionado: number;
  tituloAerovale: string;
  aerovaleDetalle: AerovaleDetalle;
  aerovaleDetalleNuevo: AerovaleDetalle;

  facturaObtenida: Comprobante;
  facturaCalculada: Factura[];
  tituloFactura: string;

  TipoSolicitudRefacturacion = TipoSolicitudRefacturacion;
  Motivo = Motivo;
  enumLegajosBusqueda = LegajosBusqueda;
  tipoSeleccionado: LegajosBusqueda = LegajosBusqueda.Solicitudes; tiposBusqueda: { key: string; value: number }[] = [];
  legajosFiltrados: LegajoAerovalesYFacturas[] = [];
  legajosFiltradosMultifiltro: LegajoAerovalesYFacturas[] = [];
  legajos: LegajoAerovalesYFacturas[] = [];
  clienteMultiFiltro: ItemMultiFiltro[] = [];
  aeroplantaMultiFiltro: ItemMultiFiltro[] = [];
  estadoAerovaleMultiFiltro: ItemMultiFiltro[] = [];
  estadoFacturaMultiFiltro: ItemMultiFiltro[] = [];
  estadoFacturaNuevaMultiFiltro: ItemMultiFiltro[] = [];
  tipoModificacionMultiFiltro: ItemMultiFiltro[] = [];
  motivoMultiFiltro: ItemMultiFiltro[] = [];
  cuentaMultiFiltro: ItemMultiFiltro[] = [];
  productoMultiFiltro: ItemMultiFiltro[] = [];
  aerovaleMultiFiltro: ItemMultiFiltro[] = [];
  legajoMultiFiltro: ItemMultiFiltro[] = [];
  aerovaleReemplazoMultiFiltro: ItemMultiFiltro[] = [];
  facturaMultiFiltro: ItemMultiFiltro[] = [];
  facturaNuevaMultiFiltro: ItemMultiFiltro[] = [];


  constructor(private calendar: NgbCalendar, private spinner: NgxSpinnerService, private facturacionService: FacturacionService, private sharedService: SharedService,
    private excelService: ExportExcelServiceService, private modalService: NgbModal, private messageService: MessageService, private comprobanteService: ComprobanteService,
    private aerovaleService: AerovalesService) { }

  ngOnInit(): void {
    this.modelDesde = this.calendar.getToday();
    this.modelHasta = this.calendar.getToday();
    this.tiposBusqueda = Object.keys(this.enumLegajosBusqueda)
      .filter(k => !isNaN(Number(this.enumLegajosBusqueda[k])))
      .map(k => ({
        key: k,
        value: this.enumLegajosBusqueda[k as keyof typeof LegajosBusqueda]
      }));
  }
  buscarDesdeHasta() {
    const fechaDesde = this.sharedService.formatDate(this.modelDesde.year, this.modelDesde.month, this.modelDesde.day, 0, 0);
    const fechaHasta = this.sharedService.formatDate(this.modelHasta.year, this.modelHasta.month, this.modelHasta.day, 23, 59)
    if(fechaHasta < fechaDesde) {
      this.messageService.showErrorMessage('La fecha de inicio no puede ser posterior a la fecha final.')
    } else {
      this.primerLlamado = true;
      this.mostrarSpinner();
      this.facturacionService.getLegajosAerovalesYFacturas(fechaDesde, fechaHasta, this.tipoSeleccionado).subscribe(l => {
        this.legajosFiltrados = l.sort((a, b) => Number(a.legajo) - Number(b.legajo));
        this.legajosFiltradosMultifiltro = this.legajosFiltrados;
        this.ocultarSpinner();
      }, (err: ErrorModel) => {
        this.messageService.showErrorMessage(err.message + err.description);
        this.ocultarSpinner();
      })
    }
  }

  recargarItems(nombre: keyof this, nuevos: ItemMultiFiltro[]) {
    (this[nombre] as ItemMultiFiltro[]) = nuevos;
    this.aplicarMultifiltro();
  }

  filtrarPorMultifiltros(lista: LegajoAerovalesYFacturas[], filtroTexto?: string): LegajoAerovalesYFacturas[] {
    const filtro = filtroTexto?.toLowerCase() || '';
  
    return lista.filter(s => {
      let mostrar = true;
  
      const checks: [ItemMultiFiltro[], any, boolean?][] = [
        [this.clienteMultiFiltro, s.cliente],
        [this.aeroplantaMultiFiltro, s.aeroplanta],
        [this.estadoAerovaleMultiFiltro, s.estadoAerovale, true],
        [this.estadoFacturaMultiFiltro, s.estadoFactura, true],
        [this.cuentaMultiFiltro, s.cuenta],
        [this.productoMultiFiltro, s.producto],
        [this.tipoModificacionMultiFiltro, s.tipoSolicitudRefacturacion, true],
        [this.motivoMultiFiltro, s.motivoRefacturacion, true],
        [this.estadoFacturaNuevaMultiFiltro, s.estadoFacturaNueva, true],
        [this.aerovaleMultiFiltro, s.aerovale],
        [this.legajoMultiFiltro, s.legajo],
        [this.aerovaleReemplazoMultiFiltro, s.aerovaleReemplazo],
        [this.facturaMultiFiltro, s.factura],
        [this.facturaNuevaMultiFiltro, s.facturaNueva]
      ];
  
      for (const [filtroArr, valor, esNumero] of checks) {
        if (filtroArr?.some(e => e.seleccionado)) {
          const valorNormalizado = valor ?? ItemMultifiltroComponent.SIMBOLO_VALOR_NULO;
          mostrar = mostrar && filtroArr.some(e => e.seleccionado && 
            (esNumero ? Number(e.id) === valorNormalizado : e.id === valorNormalizado)
          );
        }
      }
      if (!mostrar) return false;
  
      if (filtro) {
        return (
          s.cliente?.toLowerCase().includes(filtro) ||
          s.aerovale?.toString().includes(filtro) ||
          s.aerovaleReemplazo?.toString().includes(filtro) ||
          s.factura?.toString().includes(filtro) ||
          s.facturaNueva?.toString().includes(filtro) ||
          s.legajo?.toString().includes(filtro)
        );
      }
  
      return true;
    });
  }
  

  obtenerEstadoAerovale(numero: string) {
    return EstadoAerovale[numero];
  }

  obtenerEstadoFactura(numero: string) {
    return EstadoFactura[numero]
  }

  obtenerTipoModificacion(numero: number) {
    return TipoSolicitudRefacturacion[numero]
  }
  
  obtenerMotivo(numero: string) {
    return Motivo[numero]
  }

  mostrarSpinner() {
    this.spinner.show('spinnerGrafico');
    this.cargandoLista = true;
  }

  ocultarSpinner() {
    this.spinner.hide('spinnerGrafico');
    this.cargandoLista = false;
  }

  formatLabel(key: string): string {
    return key.replace(/_/g, ' ');
  }

  aplicarMultifiltro() {
    this.legajosFiltradosMultifiltro = this.filtrarPorMultifiltros(this.legajosFiltrados);
  }
  
  filtrarLegajos() {
    this.legajosFiltradosMultifiltro = this.filtrarPorMultifiltros(
      this.legajosFiltrados,
      this.busquedaFormControl.value
    );
  }
  
  descargarExcel() {
    const arrayLegajos = this.legajosFiltradosMultifiltro.map(s => ({
      'Legajo': s.legajo,
      'Fecha': this.formatFecha(s.fecha),
      'Aerovale': s.aerovale,
      'Fecha aerovale': this.formatFecha(s.aerovaleFecha),
      'Estado del aerovale': EstadoAerovale[s.estadoAerovale],
      'Adjunto':  s.adjunto ? "si" : "no",
      'Aeroplanta': s.aeroplanta,
      'Operador': s.operador,
      'Producto': s.producto,
      'Cantidad': s.cantidad,
      'Matricula': s.matricula,
      'Remito': s.remito,
      'Cuenta': s.cuenta,
      'Numero Cuenta': s.nroCuenta,
      'Factura aerov original': s.factura || '--',
      'Fecha factura  aerov original': this.formatFecha(s.fechaFactura),
      'Estado Factura': EstadoFactura[s.estadoFactura],
      'Nota de credito': s.notaCredito && this.esNotaCredito(s.notaCredito) ? s.notaCredito : '--',
      'Fecha Nota credito':s.notaCredito && this.esNotaCredito(s.notaCredito) ? this.formatFecha(s.fechaNotaCredito) : "--",
      'Nota de debito': s.notaCredito && !this.esNotaCredito(s.notaCredito) ? s.notaCredito : '--',
      'Fecha nota debito': s.notaCredito && !this.esNotaCredito(s.notaCredito) ? this.formatFecha(s.fechaNotaCredito) : "--",
      'Rancho': s.rancho || '--',
      'Reemplazo / anulacion?': this.obtenerTipoModificacion(s.tipoSolicitudRefacturacion),
      'Comentario anulación Aerovale': s.comentario || '--',
      'Aerovale reemplazo': (s.aerovaleReemplazo && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ?  s.aerovaleReemplazo : '--',
      'Fecha reemplazo': (s.fechaReemplazo && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion && !(s.motivoRefacturacion == Motivo.Despacho && s.tipoSolicitudRefacturacion == TipoSolicitudRefacturacion.Manual)) ?  this.formatFecha(s.fechaReemplazo) : '--',
      'Fecha del nuevo aerovale': (s.aerovaleReemplazo && s.fechaFinDespacho && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion && !(s.motivoRefacturacion == Motivo.Despacho && s.tipoSolicitudRefacturacion == TipoSolicitudRefacturacion.Manual)) ?  this.formatFecha(s.fechaFinDespacho) : '--',
      'Producto nuevo': (s.productoReemplazante && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ? s.productoReemplazante : '--',
      'Cantidad nuevo': (s.cantidadReemplazante && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ? s.cantidadReemplazante : '--',
      'Matricula nuevo': (s.matriculaReemplazante && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ?  s.matriculaReemplazante : '--',
      'Remito nuevo': (s.remitoReemplazante && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ? s.remitoReemplazante : '--',
      'Rancho nuevo': (s.ranchoReemplazante && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ? s.ranchoReemplazante : '--',
      'Cuenta nuevo': (s.cuentaNuevo && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ? s.cuentaNuevo : '--',
      'Nro cuenta nuevo':(s.nroCuentaNuevo && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ? s.nroCuentaNuevo : '--',
      'Factura nueva': (s.facturaNueva && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ? s.facturaNueva : '--',
      'Fecha factura  nueva': (s.facturaNueva && s.fecha && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ? s.fecha : '--',
      'Estado factura nueva': (s.estadoFacturaNueva && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ? EstadoFactura[s.estadoFacturaNueva] : '--'
    }));
  
    this.excelService.exportAsExcelFile(arrayLegajos, 'LegajosAerovalesFacturas');
  }
  
  esNotaCredito(nota: string) {
    return nota.startsWith("NC");
  }

  private formatFecha(fechaStr: string): string {
    if (!fechaStr) return "--"
    const fecha = new Date(fechaStr);
    return this.sharedService.formatDate(
      fecha.getFullYear(),
      fecha.getMonth() + 1,
      fecha.getDate(),
      fecha.getHours(),
      fecha.getMinutes()
    );
  }

  verComparativasFacturas(content, legajo: LegajoAerovalesYFacturas, index) {
    const [tipoStr, prefijo, numeroComprobante] = legajo.factura.split("-");
    const tipoMovimiento = TipoMovimiento[tipoStr as keyof typeof TipoMovimiento];
    this.tituloFactura = 'Factura: ' + prefijo + '-' + numeroComprobante + ' Fecha: ' + legajo.fecha;

    this.previsualizando = true;
    this.itemSeleccionado = index;
    this.comprobanteService.obtenerComprobantePorPrefijoNumeroTipo(Number(prefijo), Number(numeroComprobante), tipoMovimiento)
      .subscribe(result => {
        this.facturaObtenida = result;
        if (result != null) {
          this.facturacionService.getNuevoComprobante(legajo.refacturacionId, legajo.esRefacturacionTotal)
            .subscribe(result => {
              this.facturaCalculada = result;
              this.previsualizando = false;
              this.itemSeleccionado = -1;
              this.modalService.open(content, { windowClass: 'custom-modal', centered: true, size: 'xl' });
            }, (err: ErrorModel) => {
              this.previsualizando = false;
              this.itemSeleccionado = -1;
              this.messageService.showErrorMessage('Hubo un error al obtener la comparativa. ' + err.description + ' ' + err.message);
            });
        }
        else {
          this.previsualizando = false;
          this.itemSeleccionado = -1;
          this.facturaObtenida = null;
        }
      }, (err: ErrorModel) => {
        this.previsualizando = false;
        this.itemSeleccionado = -1;
        this.messageService.showErrorMessage('Hubo un error al obtener la comparativa. ' + err.description + ' ' + err.message);
      });
  }

  verComparativasAerovales(contentAerovale, legajo: LegajoAerovalesYFacturas, index) {
    const [prefijo, numeroComprobante] = legajo.aerovale.split("-");
    const [prefijoNuevo, numeroComprobanteNuevo] = legajo.aerovaleReemplazo.split("-");

    this.previsualizandoAerovale = true;
    this.itemSeleccionado = index;
    this.tituloAerovale = 'Aerovale: ' + prefijo + '-' + numeroComprobante + ' Fecha: ' + new Date().toLocaleDateString();
    this.aerovaleService.getPorPrefijoYPorNumero(Number(prefijo), Number(numeroComprobante))
      .subscribe(aerovaleDetalle => {
        this.aerovaleDetalle = aerovaleDetalle;
        if (Number(prefijoNuevo) == 0 && Number(numeroComprobanteNuevo) === 0) {
          this.facturacionService.getObtenerAerovaleReemplazoPendiente(legajo.aerovaleSolicitanteId)
            .subscribe((aerovaleReemplazo) => {
              this.aerovaleDetalleNuevo = JSON.parse(aerovaleReemplazo.aerovaleReemplazoJson);
              this.previsualizandoAerovale = false;
              this.itemSeleccionado = -1;
              this.modalService.open(contentAerovale, { windowClass: 'custom-modal', centered: true, size: 'xl' });
            });
        } else {
          this.aerovaleService.getPorPrefijoYPorNumero(Number(prefijoNuevo), Number(numeroComprobanteNuevo))
            .subscribe(aerovaleDetalle => {
              this.aerovaleDetalleNuevo = aerovaleDetalle;
              this.previsualizandoAerovale = false;
              this.itemSeleccionado = -1;
              this.modalService.open(contentAerovale, { windowClass: 'custom-modal', centered: true, size: 'xl' });
            });
        }
      }, (err: ErrorModel) => {
        this.previsualizandoAerovale = false;
        this.itemSeleccionado = -1;
        this.messageService.showErrorMessage('Hubo un error al obtener la comparativa. ' + err.description + ' ' + err.message);
      });
  }


  onDesdeChange(): void {
    if (!this.modelDesde || !this.modelHasta) return;
  
    const desde = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    const hasta = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
  
    const max = new Date(desde);
    max.setMonth(max.getMonth() + 1);
  
    this.minFechaHasta = { ...this.modelDesde };
    this.maxFechaHasta = { year: max.getFullYear(), month: max.getMonth() + 1, day: max.getDate() };
  
    if (desde < hasta && hasta > max) {
      this.modelHasta = { ...this.maxFechaHasta };
    }
  }
  
  
  // Helper para formatear Date a string compatible con input[type=date]
  formatDate(d: Date): string {
    const mm = (d.getMonth() + 1).toString().padStart(2, '0');
    const dd = d.getDate().toString().padStart(2, '0');
    return `${d.getFullYear()}-${mm}-${dd}`;
  }
  

}
